import React from "react";
import styled from "styled-components";
import {
  ColorBlack,
  ColorDarkBlack,
  ColorLightBlack,
  ColorLineGray,
  ColorMainBlue,
} from "../../Utiles/Color";
import { Container, Text } from "../../Assets/css/common";
import askCard01 from "../../Assets/images/ask_card01.png";
import askCard02 from "../../Assets/images/ask_card02.png";
import askCard03 from "../../Assets/images/ask_card03.png";
import askCard04 from "../../Assets/images/ask_card04.png";

const askCards = [
  {
    image: askCard01,
    alt: "고객 후기 이미지 1",
    description:
      "수시로 변동되는 병원의 품목 마스터를 엑셀로 관리하다보니 이력관리도 안되고 실수가 잦아져 항상 공급업체의 지원자료를 받아야 했습니다. Canon ERP는 이러한 부분들을 효율적으로 병원이 주도적으로 구매관리 할 수 있게 지원해줘서 편리합니다.",
    hospital: "00병원",
    position: "구매팀장",
  },
  {
    image: askCard02,
    alt: "고객 후기 이미지 2",
    description:
      "기존에 사용하던 범용 ERP의 경우 병원의 맞춤 시스템이 아니기 때문에 사용하는데 있어 한계점이 항상 있었습니다. Canon ERP의 병원에 맞춤형 기능들을 통해 이러한 사용 한계점을 개선할 수 있었습니다.",
    hospital: "00병원",
    position: "행정원장",
  },
  {
    image: askCard03,
    alt: "고객 후기 이미지 3",
    description:
      "병원의 특수성으로 인한 공급 프로세스가 타 병원과 상이한 부분이 많아 적합한 병원 전용 구매시스템을 찾기가 어려웠습니다. Canon ERP의 경우 구매, 재고관리 큰 기능을 표준화하고 각 기능들을 매우 세분화 하여 여러 프로세스들을 적합하게 적용할 수 있다는 장점이 있습니다.",
    hospital: "00병원",
    position: "총무과장",
  },
  {
    image: askCard04,
    alt: "고객 후기 이미지 4",
    description:
      "현재 병원에 이직하기전 사용하던 시스템이 Canon ERP 였었습니다. 새로운 환경에서 ERP 도입의 필요성을 느끼고 타사 병원 전용 ERP와 비교하였으나, 조회 속도와 기능 면에서 Canon ERP 선택하게 되었습니다.",
    hospital: "00병원",
    position: "총무팀장",
  },
];

function MainAsk() {
  return (
    <>
      <Wrapper>
        <Container>
          <Text
            as="h3"
            color={ColorDarkBlack}
            weight={"700"}
            align={"center"}
            className="text-1.5xl md:text-4xl lg:text-5xl break-keep"
          >
            고객에게 물었습니다. <br />
            <span style={{ color: ColorMainBlue }}>
              왜 Canon ERP를 선택했나요?
            </span>
          </Text>
          <CardGrid>
            {askCards.map((card, idx) => (
              <Card key={`${card.position}-${idx}`}>
                <CardImage>
                  <img src={card.image} alt={card.alt} />
                </CardImage>
                <CardBody>
                  <Text color={ColorLightBlack} className="text-sm md:text-base">
                    {card.description}
                  </Text>
                </CardBody>
                <CardFooter>
                  <Text color={ColorBlack} weight={"600"} className="text-sm">
                    {card.hospital}
                  </Text>
                  <Text color={ColorBlack} weight={"700"} className="text-lg">
                    {card.position}
                  </Text>
                </CardFooter>
              </Card>
            ))}
          </CardGrid>
        </Container>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  padding: 120px 0;
  overflow: hidden;

  @media all and (max-width: 767px) {
    padding: 50px 0;
  }
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  margin-top: 50px;

  @media all and (max-width: 1023px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media all and (max-width: 767px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 16px;
    margin-top: 24px;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  border: 1px solid ${ColorLineGray};
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
`;

const CardImage = styled.div`
  position: relative;
  padding-bottom: 78%;
  background-color: #f5f5f5;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardBody = styled.div`
  flex: 1;
  padding: 20px 18px 0;

  p {
    line-height: 1.7;
    word-break: keep-all;
  }

  @media all and (max-width: 767px) {
    padding: 16px 14px 0;

    p {
      line-height: 1.6;
    }
  }
`;

const CardFooter = styled.div`
  padding: 28px 18px 18px;
  text-align: right;

  p + p {
    margin-top: 4px;
  }

  @media all and (max-width: 767px) {
    padding: 24px 14px 16px;
  }
`;

export default MainAsk;
